import {RootStore} from '../../../stores/RootStore';
import {QuantityCalculator} from '@wix/wixstores-client-core/dist/es/src/quantity-calculator/quantityCalculator';
import {MAX_QUANTITY_INPUT, MIN_QUANTITY_INPUT} from '../../../config/constants';
import {GqlProduct} from '../../../../../types/type';

export const getQuantityRange = (rootStore: RootStore): {max: number; min: number} => {
  const {$state} = rootStore;
  const quantities = QuantityCalculator.getQuantitiesRange($state.product as GqlProduct, $state.optionSelections, {
    fixNegativeInventoryForPreOrder: true,
  });
  return {
    max: quantities.length > 0 ? quantities[quantities.length - 1] : MAX_QUANTITY_INPUT,
    min: quantities[0] ?? MIN_QUANTITY_INPUT,
  };
};
